import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import json from './block.json';
import Edit from './edit';
import Save from './save';
import Icon from './images/icons';
import { getBlockLabelByName } from '@helpers/utils';

const { name, attributes, title } = json;

registerBlockType(name, {
  attributes,
  icon: Icon.contentGater,
  edit: Edit,
  save: Save,
  __experimentalLabel: (attributes) => getBlockLabelByName(attributes, title),
});
